import { STEP_SECONDS, WIDTH } from './constants';
import type { LevelConfig } from './levels';
import type { MovingObject, Rect, Vehicle } from './state';

export function moveObject(o: MovingObject, speed = o.speed): void {
  o.previousX = o.x; o.dx = speed * STEP_SECONDS; o.x += o.dx; o.wrapped = false;
  if (o.dx > 0 && o.x > WIDTH) { o.x -= o.period; o.wrapped = true; o.cycle++; }
  if (o.dx < 0 && o.x + o.w < 0) { o.x += o.period; o.wrapped = true; o.cycle++; }
}
export function createTraffic(config: LevelConfig): Vehicle[] {
  return config.roads.flatMap(l => Array.from({length:l.count}, (_,i) => {
    const x = l.offset + i * l.period/l.count - (i ? 40 : 0);
    return { id:`road-${l.lane}-${i}`, x, previousX:x, dx:0, y:l.y, w:l.width,
      speed:l.speed, period:l.period, wrapped:false, cycle:0, lane:l.lane, kind:l.kind };
  }));
}
export function vehicleBoxes(v: Vehicle, x = v.x): Rect[] {
  // Body plus inset cab: silhouettes avoid treating transparent corner pixels
  // as a full sprite-sized rectangle.
  const base = { x:x+2, y:v.y-4, w:v.w-4, h:8 };
  return [base, {x:x+5,y:v.y-6,w:Math.max(5,v.w-10),h:12}];
}
